// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Analytics Page  Premium Dashboard */

.kpi-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-bottom: 28px;
}

.kpi-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 24px;
  position: relative;
  overflow: hidden;
  transition: box-shadow 0.2s, transform 0.2s;
}

.kpi-card:hover {
  box-shadow: 0 10px 25px rgba(0,0,0,0.08);
  transform: translateY(-2px);
}

.kpi-card::before {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 3px;
  background: linear-gradient(90deg, #3b82f6, #8b5cf6);
}

.kpi-card:nth-child(2)::before { background: linear-gradient(90deg, #22c55e, #10b981); }
.kpi-card:nth-child(3)::before { background: linear-gradient(90deg, #f59e0b, #f97316); }
.kpi-card:nth-child(4)::before { background: linear-gradient(90deg, #8b5cf6, #ec4899); }

.kpi-value {
  font-size: 2.2rem;
  font-weight: 800;
  color: #0f172a;
  letter-spacing: -0.03em;
  line-height: 1;
  margin-bottom: 6px;
}

.kpi-label {
  font-size: 0.82rem;
  color: #64748b;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.analytics-header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 24px;
}

.analytics-header h1 { display: none; }

.range-selector {
  display: flex;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 4px;
  gap: 2px;
}

.range-selector .btn {
  border-radius: 8px;
  padding: 8px 18px;
  font-size: 0.82rem;
  font-weight: 600;
}

.range-selector .btn-secondary {
  background: transparent;
  color: #64748b;
}

.range-selector .btn-secondary:hover:not(:disabled) {
  background: #f1f5f9;
  color: #334155;
}

.range-selector .btn-primary {
  box-shadow: 0 1px 3px rgba(59,130,246,0.3);
}

.analytics-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.chart-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 24px;
  transition: box-shadow 0.2s;
}

.chart-card:hover {
  box-shadow: 0 10px 25px rgba(0,0,0,0.08);
}

.chart-card h3 {
  font-size: 0.92rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 20px;
}

@media (max-width: 1200px) { .kpi-grid { grid-template-columns: repeat(2, 1fr); } }
@media (max-width: 768px) {
  .kpi-grid { grid-template-columns: 1fr; }
  .analytics-grid { grid-template-columns: 1fr; }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Analytics.css"],"names":[],"mappings":"AAAA,sCAAsC;;AAEtC;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ;EACzB,WAAW;EACX,oDAAoD;AACtD;;AAEA,iCAAiC,oDAAoD,EAAE;AACvF,iCAAiC,oDAAoD,EAAE;AACvF,iCAAiC,oDAAoD,EAAE;;AAEvF;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,uBAAuB,aAAa,EAAE;;AAEtC;EACE,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,6BAA6B,YAAY,qCAAqC,EAAE,EAAE;AAClF;EACE,YAAY,0BAA0B,EAAE;EACxC,kBAAkB,0BAA0B,EAAE;AAChD","sourcesContent":["/* Analytics Page  Premium Dashboard */\n\n.kpi-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 20px;\n  margin-bottom: 28px;\n}\n\n.kpi-card {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 24px;\n  position: relative;\n  overflow: hidden;\n  transition: box-shadow 0.2s, transform 0.2s;\n}\n\n.kpi-card:hover {\n  box-shadow: 0 10px 25px rgba(0,0,0,0.08);\n  transform: translateY(-2px);\n}\n\n.kpi-card::before {\n  content: '';\n  position: absolute;\n  top: 0; left: 0; right: 0;\n  height: 3px;\n  background: linear-gradient(90deg, #3b82f6, #8b5cf6);\n}\n\n.kpi-card:nth-child(2)::before { background: linear-gradient(90deg, #22c55e, #10b981); }\n.kpi-card:nth-child(3)::before { background: linear-gradient(90deg, #f59e0b, #f97316); }\n.kpi-card:nth-child(4)::before { background: linear-gradient(90deg, #8b5cf6, #ec4899); }\n\n.kpi-value {\n  font-size: 2.2rem;\n  font-weight: 800;\n  color: #0f172a;\n  letter-spacing: -0.03em;\n  line-height: 1;\n  margin-bottom: 6px;\n}\n\n.kpi-label {\n  font-size: 0.82rem;\n  color: #64748b;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.analytics-header {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.analytics-header h1 { display: none; }\n\n.range-selector {\n  display: flex;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 4px;\n  gap: 2px;\n}\n\n.range-selector .btn {\n  border-radius: 8px;\n  padding: 8px 18px;\n  font-size: 0.82rem;\n  font-weight: 600;\n}\n\n.range-selector .btn-secondary {\n  background: transparent;\n  color: #64748b;\n}\n\n.range-selector .btn-secondary:hover:not(:disabled) {\n  background: #f1f5f9;\n  color: #334155;\n}\n\n.range-selector .btn-primary {\n  box-shadow: 0 1px 3px rgba(59,130,246,0.3);\n}\n\n.analytics-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n}\n\n.chart-card {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 24px;\n  transition: box-shadow 0.2s;\n}\n\n.chart-card:hover {\n  box-shadow: 0 10px 25px rgba(0,0,0,0.08);\n}\n\n.chart-card h3 {\n  font-size: 0.92rem;\n  font-weight: 700;\n  color: #1e293b;\n  margin-bottom: 20px;\n}\n\n@media (max-width: 1200px) { .kpi-grid { grid-template-columns: repeat(2, 1fr); } }\n@media (max-width: 768px) {\n  .kpi-grid { grid-template-columns: 1fr; }\n  .analytics-grid { grid-template-columns: 1fr; }\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
